// Keep the illustration quiet when it cannot be seen or motion is unwanted.
export function observeHeroMotion(root, update, environment = window) {
  const document = environment.document;
  const preference = environment.matchMedia('(prefers-reduced-motion: reduce)');
  let visible = !environment.IntersectionObserver;
  const notify = () => update({ reduced: preference.matches, active: visible && !document.hidden });
  const observer = environment.IntersectionObserver
    ? new environment.IntersectionObserver(([entry]) => { visible = entry.isIntersecting; notify(); }, { threshold: 0 })
    : null;
  observer?.observe(root);
  preference.addEventListener('change', notify);
  document.addEventListener('visibilitychange', notify);
  notify();
  return () => {
    observer?.disconnect();
    preference.removeEventListener('change', notify);
    document.removeEventListener('visibilitychange', notify);
  };
}
